import { render, staticRenderFns } from "./select_widget.vue?vue&type=template&id=fdfd3e86&scoped=true"
import script from "./select_widget.vue?vue&type=script&lang=js"
export * from "./select_widget.vue?vue&type=script&lang=js"
import style0 from "./select_widget.vue?vue&type=style&index=0&id=fdfd3e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfd3e86",
  null
  
)

export default component.exports